import React from 'react';
import { Page } from '../../components';
import { Typography } from '@mui/material';

export const NoAccess = () => {
  return (
    <Page title={'401'}>
      <Typography variant="h4">401 Unauthorized</Typography>
      <Typography variant="body1">
        Contact support if you feel you have reached this in error.
      </Typography>
    </Page>
  );
};
